import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { SelectFilterCreator, SelectTriggerLabelExtractor } from '@dreryk/react-components';

const SELECTED_PRACTITIONER_ID_KEY = 'specialistTimetableSelectedPractitionerId';

export const practitionerSelectorStorage = {
   setPractitionerId: (practitionerId: PractitionerId): void => {
      window.localStorage.setItem(SELECTED_PRACTITIONER_ID_KEY, practitionerId.toString());
   },
   getPractitionerId: (): number | null => {
      const practitionerId = window.localStorage.getItem(SELECTED_PRACTITIONER_ID_KEY);

      if (practitionerId && !isNaN(parseInt(practitionerId, 10))) {
         return Number(practitionerId);
      }

      return null;
   },
};

export const sortPractitionerByLastName = (
   practitionerA: AppointmentPractitioner,
   practitionerB: AppointmentPractitioner
): 1 | -1 | 0 => {
   const practitionerALastName = practitionerA.lastName.asString().toLowerCase();
   const practitionerBLastName = practitionerB.lastName.asString().toLowerCase();
   if (practitionerALastName > practitionerBLastName) {
      return 1;
   }
   if (practitionerALastName < practitionerBLastName) {
      return -1;
   }
   return 0;
};

export const triggerLabelExtractor: SelectTriggerLabelExtractor<AppointmentPractitioner> = (practitioner): string =>
   `${practitioner.lastName.asString()} ${practitioner.firstName.asString()}`;

export const filterPractitionerByFullName: SelectFilterCreator<AppointmentPractitioner> = ({ includes }) => (
   practitioner
) => includes(triggerLabelExtractor(practitioner));
